const Colors = {
    primaryblue: '#142456',
    buttonColor: '#142456',
    darkTextColor: '#1F2937',
    tableRow: '#F2F2F6',
    darkblue: '#202A44',
    lightblue: '#1F2937',
    lightwhite: '#E5E7EB',
    iconcolor: '#323232',
};

export default Colors;
